import { FunctionComponent } from 'react';
import DOMPurify from 'dompurify';
import { styled } from 'styled-components';
import { paletteHelper, spacingHelper, typographyHelper } from '@property.com.au/ui-kit';
import { ProptrackLogoBrickSource } from '../ProptrackLogoBrickSource/ProptrackLogoBrickSource';

const DisclaimerContent = styled.div`
  p {
    ${typographyHelper('body01')};
    color: ${paletteHelper('textSecondary')};
  }

  p.state-title {
    ${typographyHelper('body01Bold')};
  }
  h2 {
    display: flex;
    ${typographyHelper('subtitle01')};
    align-items: center;
    gap: ${spacingHelper('extraSmall')};
  }

  ol {
    ${typographyHelper('body01')};
    color: ${paletteHelper('textSecondary')};
    list-style-position: inside;
  }

  a {
    color: ${paletteHelper('textSecondary')};

    &:focus {
      color: ${paletteHelper('textSecondary')};
    }

    &:link {
      color: ${paletteHelper('textSecondary')};
    }
  }
`;

interface VGDisclaimerModalContentProps {
  vgDisclaimerHtml: string | null;
}

export const VGDisclaimerContent: FunctionComponent<VGDisclaimerModalContentProps> = ({
  vgDisclaimerHtml,
}) => (
  <DisclaimerContent>
    <h2>
      Sold data <ProptrackLogoBrickSource />
    </h2>
    <br />
    <p>
      This information is supplied by realestate.com.au (ABN 21 080 195 535) on behalf of Proptrack
      Pty Ltd (ABN 43 127 386 298)
    </p>
    <br />

    {vgDisclaimerHtml && (
      <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(vgDisclaimerHtml) }} />
    )}
  </DisclaimerContent>
);
